export interface NewCharitySummaryData {
  charityName: string;
  charityRegistrationNumber: string;
  amount: number;
  currency: string;
  country: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  charityAddress: string;
  comments: string;
}

export interface NewCharityPayload extends NewCharitySummaryData {
  currencySymbol: string;
  loggedInName: string;
  fundName: string;
}

export function buildSummaryData(formValue: any, fund: any): NewCharitySummaryData {
  return {
    charityName: formValue.charityName,
    charityRegistrationNumber: formValue.registrationNumber,
    amount: formValue.amount,
    currency: formValue.currency?.symbol ?? fund?.currency,
    country: formValue.country,
    contactName: formValue.contactName,
    contactEmail: formValue.contactEmail,
    contactPhone: formValue.contactPhone,
    charityAddress: formValue.charityAddress,
    comments: formValue.comments,
  };
}

export function buildPayload(
  formValue: any,
  fund: any,
  userName: string
): NewCharityPayload {
  return {
    ...buildSummaryData(formValue, fund),
    currency: formValue.currency?.id ?? formValue.currency?.symbol ?? fund?.currency,
    currencySymbol: formValue.currency?.symbol ?? fund?.currencySymbol ?? fund?.currency,
    loggedInName: userName,
    fundName: fund?.fundName,
  };
}
